import { clsx } from 'clsx';
import { FC } from 'react';
import { Body, Price as PriceTypography } from 'atoms/Typography/Typography';
import { usePrice } from 'modules/formatter/hooks';
import styles from './price.module.css';

type PriceT = {
  amount?: number | null;
  currencyCode?: string;
  className?: string;
} & (
  | {
      isCrossed: true;
      size?: 'regular' | 'small';
      color?: 'red' | 'white';
    }
  | {
      isCrossed: false;
      size: 'regular' | 'small' | 'large';
      color?: 'white';
    }
);

export const Price: FC<PriceT> = ({
  amount,
  currencyCode,
  className,
  ...props
}) => {
  const price = usePrice(amount, currencyCode);

  if (!price) {
    return null;
  }

  if (props.isCrossed) {
    return props.size === 'small' ? (
      <PriceTypography
        type="sm"
        className={clsx(
          styles.root,
          props.isCrossed && styles.crossed,
          props?.color && styles[props.color],
          className,
        )}
      >
        {price.currency} {price.amount}
      </PriceTypography>
    ) : (
      <Body
        type="sm"
        className={clsx(
          styles.root,
          props.isCrossed && styles.crossed,
          props?.color && styles[props.color],
          className,
        )}
      >
        {price.currency} {price.amount}
      </Body>
    );
  }

  const getPriceType = () => {
    switch (props.size) {
      case 'large':
        return 'lg';
      case 'small':
        return 'sm';
      default:
        return 'md';
    }
  };

  return (
    <PriceTypography
      type={getPriceType()}
      className={clsx(
        styles.root,
        props?.color && styles[props.color],
        className,
      )}
    >
      {price.currency} {price.amount}
    </PriceTypography>
  );
};
